export default "__VITE_ASSET__bb7462d3__"